import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY } from './config';

/**
 * Browser client. The publishable key grants nothing on its own: every table
 * this app touches requires an approved i18n_member row, enforced by RLS. An
 * anonymous session — which is what the iOS app holds — sees no rows at all.
 */
export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});
